<template>
  <div class="about-video section-gap mt-3">
    <div class="container">
      <!-- <div class="card border-0 shadow-md text-white border-rad"> -->
        <!-- <span
          class="_addtoFav py-2 px-3 position-absolute"
          @click.stop="UpdateStatus(ListOfData)"
        >
          <i
            class="fa fa-heart text-white fa-2x"
            v-if="ListOfData.IsFavorite"
          ></i>
          <i class="far fa-heart text-white fa-2x" v-else></i>
        </span> -->
        <!-- <img
          class="border-rad img-fluid"
          v-if="ListOfData.Attachments.AttachmentURL"
          :src="baseURL + ListOfData.Attachments.AttachmentURL"
          alt="Card image"
          width="1170"
          height="400"
        />
        <img
          v-else
          src="/static/img/enNotAvail.png"
          alt=""
          height="250"
          class="card-img-top border-bottom"
        /> -->
      
      <!-- </div> -->
      <!-- <div class="col-sm-12 col-md-12 col-lg-6 product-detail-content mb-4"> -->
        <div class="mb-3">

          <textarea class="vx-col md:w-1/2 sm:w-1/2 w-full mb-4"
          v-model="ListOfData.ArticleText"
          name="ArticleText"
          style="height: 600px; width: 600px; text-align: center; direction: rtl; overflow-y: auto;"></textarea>
          <!-- </vs-textarea> -->
          <h4 class="mb-3">{{ ListOfData.Name }}</h4>
          <div class="mb-3">{{ ListOfData.AuthorName }}</div>

          <!-- <h6 v-if="ListOfData.CreatedByName" class=" ">
            {{ $t("publishedby") }}:
          </h6>
          <div v-if="ListOfData.CreatedByName" class=" ">
            {{ ListOfData.CreatedByName }}
          </div>
          <div class=" ">
            {{ ListOfData.CreatedDate | formatDate("yyyy/MM/dd") }}
          </div> -->
        </div>
      
    </div>


    <div class="container">
      <div class="section-title-wrapper text-center">
        <div class="row">
          <div class="col-sm-12 col-md-6 mx-auto text-center">
            <p class="mb-0 lead">
              {{ ListOfData.Brief }}
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="col-sm-12 col-md-6 mx-auto">
      <button
        @click="back"
        type="border"
        class=" btn btn-primary rounded-pill text-white btn-lg rounded-pill"
      >
        {{ $t("back") }}
      </button>
    </div>
  </div>
</template>

<script>
import { domain } from "@/globalComponents.js";

import RelatedProducts from "Components/Sections/RelatedProducts.vue";
import modulePageDetails from "@/store/PageDetails/modulePageDetails.js";

export default {
  components: {
    RelatedProducts,

  },
  data() {
    return {
      ListOfData: {},
      model: {},
      baseURL: domain,
      Downloaded: false,
      ArticleText:""
      // videoContent,
    };
  },
  methods: {
    back() {
      this.$router.go(-1);
    },
    UpdateStatus(item) {
      if (this.$store.state.auth.isUserLoggedIn()) {
        let model = {};
        model.articleID = item.ID;
        this.$store
          .dispatch("DataList/ToggleUserFavorite", model)
          .then(() => {
            this.ListOfData.IsFavorite = !this.ListOfData.IsFavorite;
          })
          .catch(() => {});
        return false;
      } else {
        this.$toasted.show(this.$t("PleaseLoginFirst"), {
          theme: "outline",
          position: "bottom-center",
          duration: 5000,
        });
        return true;
      }
    },
  },
  created() {
    debugger;
    if (!modulePageDetails.isRegistered) {
      this.$store.registerModule("DetailsList", modulePageDetails);
      modulePageDetails.isRegistered = true;
    }
    let ID = this.$route.params.ID;

    this.$store
      .dispatch("DetailsList/GetArticle", ID)
      .then((response) => {
        if (response.status == 200) {
          //   alert("ٍ" + this.model.pageNumber);
          this.ListOfData = response.data.data;
          this.isMounted = true;
        }
      })
      .catch(() => {});
  },
};
</script>
<style lang="scss">
.PlayIcon {
  top: 45%;
  right: 30px;
  z-index: 500;
}
._cartBtn {
  left: 1.25rem;
}

._addtoFav {
  cursor: pointer;
}
</style>
